module.exports = __webpack_public_path__ + "static/media/CPProductPlaceholder.0731ec26.png";